import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="py-12 border-t border-white/10 transition-colors duration-300 bg-[#000000]" data-id="element-456">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-457">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-458">
          <div className="md:col-span-2" data-id="element-459">
            <Link to="/" data-id="element-460">
              <img src="https://cdn.magicpatterns.com/uploads/3C1xrkGTfVHurUv4Wdvj7g/logo_253.png" alt="253Gravel" className="h-10 w-auto mb-4" data-id="element-461" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-462">
              Premium gravel, crushed rock, and aggregate delivery serving
              Tacoma and South King County. Fast, reliable, and transparent.
            </p>
          </div>

          <div data-id="element-463">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-464">
              Contact
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-465">
              <li data-id="element-466">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-467">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-468">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-469">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-470">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-471">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-472">
              Hours
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-473">
              <li className="flex justify-between" data-id="element-474">
                <span data-id="element-475">Mon-Fri:</span>
                <span data-id="element-476">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-477">
                <span data-id="element-478">Saturday:</span>
                <span data-id="element-479">7:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-480">
                <span data-id="element-481">Sunday:</span>
                <span data-id="element-482">Closed</span>
              </li>
            </ul>
          </div>

          <div data-id="element-483">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-484">
              Resources
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-485">
              <li data-id="element-486">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-487">
                  Compare Materials
                </Link>
              </li>
              <li data-id="element-488">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-489">
                  Delivery Prep Guide
                </Link>
              </li>
              <li data-id="element-490">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-491">
                  Delivery Zones
                </Link>
              </li>
              <li data-id="element-492">
                <Link to="/diy-help" className="hover:text-white/70 transition-colors" data-id="element-493">
                  DIY Driveway Guide
                </Link>
              </li>
              <li data-id="element-494">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-495">
                  Material Quiz
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-496">
          <p data-id="element-497">
            &copy; {new Date().getFullYear()} 253Gravel. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-498">
            <a href="#" className="hover:text-white transition-colors" data-id="element-499">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-500">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}